import { CSS_PROPERTIES } from '@wix/component-protocol/schema';

type CssPropertyTypeValue =
  (typeof CSS_PROPERTIES.CSS_PROPERTY_TYPE)[keyof typeof CSS_PROPERTIES.CSS_PROPERTY_TYPE];

export const STYLE_PROPERTIES_TYPES: {
  COLOR: Record<string, CssPropertyTypeValue>;
  COLOR_SUPPORTING_SHORTHANDS: Record<string, CssPropertyTypeValue>;
  NUMBER: Record<string, CssPropertyTypeValue>;
  FONT: Record<string, CssPropertyTypeValue>;
} = {
  COLOR: {
    color: CSS_PROPERTIES.CSS_PROPERTY_TYPE.color,
    backgroundColor: CSS_PROPERTIES.CSS_PROPERTY_TYPE.backgroundColor,
    fill: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fill,
    borderColor: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderColor,
    borderTopColor: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopColor,
    borderRightColor: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRightColor,
    borderBottomColor: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottomColor,
    borderLeftColor: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderLeftColor,
    borderInlineStartColor:
      CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineStartColor,
    borderInlineEndColor: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineEndColor,
  },

  COLOR_SUPPORTING_SHORTHANDS: {
    border: CSS_PROPERTIES.CSS_PROPERTY_TYPE.border,
    borderTop: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTop,
    borderRight: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRight,
    borderBottom: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottom,
    borderLeft: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderLeft,
    borderInlineStart: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineStart,
    borderInlineEnd: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineEnd,
    background: CSS_PROPERTIES.CSS_PROPERTY_TYPE.background,
    textDecoration: CSS_PROPERTIES.CSS_PROPERTY_TYPE.textDecoration,
  },

  NUMBER: {
    number: CSS_PROPERTIES.CSS_PROPERTY_TYPE.number,
    fillOpacity: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fillOpacity,
    margin: CSS_PROPERTIES.CSS_PROPERTY_TYPE.margin,
    marginTop: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginTop,
    marginRight: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginRight,
    marginBottom: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginBottom,
    marginLeft: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginLeft,
    marginInlineStart: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginInlineStart,
    marginInlineEnd: CSS_PROPERTIES.CSS_PROPERTY_TYPE.marginInlineEnd,
    padding: CSS_PROPERTIES.CSS_PROPERTY_TYPE.padding,
    paddingTop: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingTop,
    paddingRight: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingRight,
    paddingBottom: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingBottom,
    paddingLeft: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingLeft,
    paddingInlineStart: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingInlineStart,
    paddingInlineEnd: CSS_PROPERTIES.CSS_PROPERTY_TYPE.paddingInlineEnd,
    borderWidth: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderWidth,
    borderStyle: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStyle,
    borderTopWidth: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopWidth,
    borderTopStyle: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopStyle,
    borderRightWidth: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRightWidth,
    borderRightStyle: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRightStyle,
    borderBottomWidth: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottomWidth,
    borderBottomStyle: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottomStyle,
    borderLeftWidth: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderLeftWidth,
    borderLeftStyle: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderLeftStyle,
    borderInlineStartWidth:
      CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineStartWidth,
    borderInlineStartStyle:
      CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineStartStyle,
    borderInlineEndWidth: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineEndWidth,
    borderInlineEndStyle: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderInlineEndStyle,
    borderRadius: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderRadius,
    borderTopLeftRadius: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopLeftRadius,
    borderTopRightRadius: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderTopRightRadius,
    borderBottomRightRadius:
      CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottomRightRadius,
    borderBottomLeftRadius:
      CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderBottomLeftRadius,
    borderStartStartRadius:
      CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStartStartRadius,
    borderStartEndRadius: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderStartEndRadius,
    borderEndStartRadius: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderEndStartRadius,
    borderEndEndRadius: CSS_PROPERTIES.CSS_PROPERTY_TYPE.borderEndEndRadius,
    opacity: CSS_PROPERTIES.CSS_PROPERTY_TYPE.opacity,
    gap: CSS_PROPERTIES.CSS_PROPERTY_TYPE.gap,
    height: CSS_PROPERTIES.CSS_PROPERTY_TYPE.height,
    width: CSS_PROPERTIES.CSS_PROPERTY_TYPE.width,
    columnGap: CSS_PROPERTIES.CSS_PROPERTY_TYPE.columnGap,
    rowGap: CSS_PROPERTIES.CSS_PROPERTY_TYPE.rowGap,
  },

  FONT: {
    font: CSS_PROPERTIES.CSS_PROPERTY_TYPE.font,
    fontFamily: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontFamily,
    fontStyle: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontStyle,
    fontSize: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontSize,
    fontWeight: CSS_PROPERTIES.CSS_PROPERTY_TYPE.fontWeight,
    textAlign: CSS_PROPERTIES.CSS_PROPERTY_TYPE.textAlign,
  },
} as const;
